const secondary = {
    social_bind_with: 'Vous avez déjà un compte? Connectez-vous pour lier {{methods, list(type: disjunction;)}} avec votre identité sociale.',
};
export default Object.freeze(secondary);
